







































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  定点発注検索条件型,
  定点発注検索結果一覧型,
  定点発注検索結果型,
  定点発注発注候補型,
  発注卸型,
  発注未確定登録レコード型,
  発注未確定登録型,
  発注未確定登録結果型,
} from '@/type/purchaseorder/item';
import {採用区分型, 発注入力方法区分型, 発注未確定登録区分} from '@/type/purchaseorder/types';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';

import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import WholesaleSelectorPurchaseOrder from '@/components/wholesale/WholesaleSelectorPurchaseOrder.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {定点発注追加検索条件バリデータ一覧, 定点発注追加情報バリデータ一覧} from '@/type/purchaseorder/order-validate';
import {ValidationResult} from '@/type/validation/result';
import {検索並び順区分型, 検索並び順区分一覧} from '@/type/purchaseorder/検索並び順区分型';
import AmountField from '@/components/atom/input/AmountField.vue';

@Component({
  components: {
    NormalDialog,
    WholesaleSelectorPurchaseOrder,
    ConfirmDialog,
    NormalButton,
    AmountField,
  },
})

export default class DemandForecastDialog extends Vue {
  private 定点発注検索条件: 定点発注検索条件型 = this.検索条件初期値を取得();
  private 発注候補商品リスト: 定点発注発注候補型[] = [];
  private 発注未確定登録リスト: 発注未確定登録レコード型[] = [];

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(定点発注追加検索条件バリデータ一覧);
  private 定点発注一覧バリデーション結果: ValidationResult = new ValidationResult(定点発注追加情報バリデータ一覧);
  private 発注未確定登録バリデーション結果: ValidationResult = new ValidationResult(定点発注追加情報バリデータ一覧);

  private 選択中の行index: number | null = null;
  private 次の行index: number | null = null;
  private グリッド最終行: number | null = null;
  private グリッド件数: number | null = null;
  private beforeOpened: boolean = false;

  @Prop({default: false})
  private modal!: boolean;

  @Prop({default: []})
  private wholesaleList!: 発注卸型[];

    @Watch('発注候補商品リスト.JANコード', {deep: true})
    private 数量にフォーカス(): void {
      this.$nextTick(() => {
        this.グリッド件数 = this.発注候補商品リスト.length;
        if (this.beforeOpened === true && this.グリッド件数 > 0) {
          this.入力欄を指定().数量入力欄[0].$el.childNodes[0].focus();
          this.リスト選択時の処理(0);
        }
      });
    }

  private beforeOpen() {
    const 商品名カナ入力欄 = document.getElementById('商品名カナ');
    if (商品名カナ入力欄) {
      商品名カナ入力欄.focus();
    }
    this.beforeOpened = true;
  }

  private beforeUpdate(): void {
    this.検索条件バリデーション結果.validate(this.定点発注検索条件);
    this.定点発注一覧バリデーション結果.validateList(this.発注候補商品リスト);
  }

  private get 表示件数を取得() {
    return this.発注候補商品リスト.length;
  }

  private 検索開始に移動するハンドラ(keyCode: number, repeat: boolean) {
    if (keyCode !== 13) return;
    if (repeat === true) return;
    const 検索開始ボタン = document.getElementById('検索開始');
    if (!検索開始ボタン) return;
    検索開始ボタン.focus();
  }

  get 検索並び順区分一覧(): 検索並び順区分型[] {
    return 検索並び順区分一覧;
  }

  private 絞込条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.絞込条件入力エラー判定(項目名)};
  }

  private 絞込条件入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private async 確定するハンドラ() {
    await progress(this.確定する);
  }

  private async 確定する(): Promise<void> {

    const 発注未確定登録リストに追加する対象 = this.発注未確定登録リストに追加する対象();

    if (this.発注未確定登録リスト.length === 0 && 発注未確定登録リストに追加する対象.length === 0) {
      this.$emit('show-alert', '発注する商品が選択されていません');
      return;
    }

    this.発注未確定登録バリデーション結果.validateList(発注未確定登録リストに追加する対象);
    if (this.発注未確定登録バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.発注未確定登録バリデーション結果.getMessages());
      return;
    }

    Array.prototype.push.apply(this.発注未確定登録リスト, 発注未確定登録リストに追加する対象);

    const 発注未確定登録依頼: 発注未確定登録型 = {
      発注未確定登録方法区分: 発注未確定登録区分.登録する,
      発注未確定登録レコードリスト: this.発注未確定登録リスト,
    };

    await api.発注候補商品を登録する(発注未確定登録依頼)
        .then((response: 発注未確定登録結果型) => {
          this.beforeOpened = false;
          this.$modal.hide('定点発注追加画面');
          this.$emit('finish-demand-forecast');

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
  }

  private 戻る() {
    this.beforeOpened = false;
    this.$modal.hide('定点発注追加画面');
    this.$emit('finish-demand-forecast');
  }

  private 全選択する() {
    this.選択を全て変更する(true);
  }

  private 全解除する() {
    this.選択を全て変更する(false);
  }

  private 選択を全て変更する(選択: boolean) {
    for (const 発注候補 of this.発注候補商品リスト) {
      発注候補.選択 = 選択;
    }
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.発注候補商品リスト = [];
      this.発注未確定登録リスト = [];
      this.定点発注検索条件 = this.検索条件初期値を取得();
      this.選択中の行index = null;
      this.$modal.show('定点発注追加画面');
    }
  }

  private 検索条件初期値を取得(): 定点発注検索条件型 {
    return {
      検索並び順区分: '商品名',
      商品名カナ: '',
      メーカー名: '',
    };
  }

  private 発注未確定登録リストに追加する対象(): 発注未確定登録レコード型[] {
    return this.発注候補商品リスト.filter((発注候補商品: 定点発注発注候補型) => {
        if (this.発注未確定登録リスト.some((s) => s.JANコード === 発注候補商品.JANコード)) {
          return false;
        }
        return 発注候補商品.選択 === true;
      })
      .map((発注候補商品: 定点発注発注候補型) => {
        return {
          JANコード: 発注候補商品.JANコード,
          販売GTINコード: 発注候補商品.販売GTINコード,
          備蓄商品コード: '',
          商品コード: 発注候補商品.商品コード,
          商品区分: 発注候補商品.商品区分,
          卸コード: 発注候補商品.卸コード,
          発注数: 発注候補商品.発注数,
          発注方法区分: null,
          採用フラグ: 採用区分型.採用済,
          オンライン発注可否区分: 発注候補商品.オンライン発注可否区分,
          発注入力方法区分: 発注入力方法区分型.定点発注,
          発注伝票番号: null,
          発注伝票行番号: null,
        };
      });
  }

  private async 検索するハンドラ(repeat: boolean) {
    if (repeat === true) return;
    if (this.検索条件バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.検索条件バリデーション結果.getMessages());
      return;
    }

    await progress(this.検索する);
  }

  private async 確認後の検索するハンドラ() {
    this.ダイアログを閉じる('定点発注選択中確認ダイアログ');
    await progress(this.検索する);
  }

  private async 検索する(): Promise<void> {

    const 発注未確定登録リストに追加する対象 = this.発注未確定登録リストに追加する対象();

    this.発注未確定登録バリデーション結果.validateList(発注未確定登録リストに追加する対象);
    if (this.発注未確定登録バリデーション結果.hasErrors) {
      this.$emit('show-alert', this.発注未確定登録バリデーション結果.getMessages());
      return;
    }

    Array.prototype.push.apply(this.発注未確定登録リスト, 発注未確定登録リストに追加する対象);

    await api.定点発注を検索する(this.定点発注検索条件)
        .then((response: 定点発注検索結果一覧型) => {
          this.発注候補商品リスト = response.定点発注検索結果レコードリスト.map((定点発注: 定点発注検索結果型) => {
            return {
              選択: this.発注未確定登録リスト.some((s) => s.JANコード === 定点発注.JANコード),
              商品区分: 定点発注.商品区分,
              メーカー名: 定点発注.メーカー名,
              商品名: 定点発注.商品名,
              規格容量: 定点発注.規格容量,
              卸コード: 定点発注.卸コード,
              発注数: 定点発注.発注数,
              院内在庫数: 定点発注.院内在庫数,
              単位名: 定点発注.単位名,
              未入庫数: 定点発注.未入庫数,
              商品コード: 定点発注.商品コード,
              JANコード: 定点発注.JANコード,
              販売GTINコード: 定点発注.販売GTINコード,
              オンライン発注可否区分: 定点発注.オンライン発注可否区分,
              経過措置区分: 定点発注.経過措置区分,
              表示未入庫数: 定点発注.表示未入庫数,
              表示未確定発注数: 定点発注.表示未確定発注数,
              表示予定在庫数: 定点発注.表示予定在庫数,
              表示入数: 定点発注.表示入数,
              表示発注点: 定点発注.表示発注点,
              表示確保数: 定点発注.表示確保数,
              表示発注数: 定点発注.表示発注数,
            };
          });

          if (this.発注候補商品リスト.length === 0) {
            this.$emit('show-alert', '商品が見つかりませんでした');
            return;
          }

          if (response.アラートメッセージ) {
            this.$emit('show-alert', response.アラートメッセージ);
          }

        }).catch((error: any) => {
          this.$emit('show-alert', error.data.message);
        });
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private 経過措置状態クラス(index: number, 発注候補商品: 定点発注発注候補型): string {
    if (this.行が選択されている(index)) {
      return 'selected';
    }
    if (発注候補商品.経過措置区分 === '経過措置期間') {
      return '経過措置期間';
    }
    if (発注候補商品.経過措置区分 === '経過措置終了') {
      return '経過措置終了';
    }
    return '';
  }

  private 定点発注一覧エラー判定(index: number, 項目名: string): boolean {
    return this.定点発注一覧バリデーション結果.hasError(項目名, index);
  }

  private 入力欄を指定(): any {
    return this.$refs;
  }

  private 次の行の数量に移動(index: number, keyupCode: number, repeat: boolean): void {
    if (keyupCode !== 13) return;
    if (repeat === true) return;
    this.次の行index = index + 1;
    this.グリッド最終行 = (this.表示件数を取得) - 1;
    if (this.グリッド最終行 >= this.次の行index) {
      this.入力欄を指定().数量入力欄[this.次の行index].$el.childNodes[0].focus();
      this.リスト選択時の処理(this.次の行index);
    } else {
      this.入力欄を指定().数量入力欄[index].$el.childNodes[0].blur();
    }
    this.数量フォーカス移動時選択チェック(index);
  }

  private 数量フォーカス移動時選択チェック(index: number): void {
    if (this.発注候補商品リスト[index].発注数 > 0) {
      this.発注候補商品リスト[index].選択 = true;
    } else {
      this.発注候補商品リスト[index].選択 = false;
    }
  }
}

